function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_image"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m19 4h-9c-.553 0-1 .447-1 1s.447 1 1 1h9c.552 0 1 .448 1 1v9c0 .553.447 1 1 1s1-.447 1-1v-9c0-1.654-1.346-3-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.707 2.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l.907.907c-.723.549-1.2 1.409-1.2 2.386v10c0 1.654 1.346 3 3 3h13.586l1.707 1.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm4.293 7.207c0 .275-.225.5-.5.5s-.5-.225-.5-.5c0-.317.349-.552.619-.467l.354.354c.01.037.027.072.027.113zm-1.946-2.032c-.636.454-1.054 1.193-1.054 2.032 0 1.379 1.121 2.5 2.5 2.5.839 0 1.578-.418 2.032-1.054l2.054 2.054-1.586 1.586-.879-.879c-1.17-1.17-3.072-1.17-4.242 0l-.879.879v-7.586c0-.43.274-.789.655-.931zm-1.054 10.532c-.43 0-.789-.274-.931-.655l2.224-2.224c.375-.373 1.039-.373 1.414 0l1.586 1.586c.391.391 1.023.391 1.414 0l2.293-2.293 3.586 3.586z"
})));

var Svg074Image = function Svg074Image(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg074Image, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/074-image.44d0edd7.svg";
export { ForwardRef as ReactComponent };